module.exports = __webpack_public_path__ + "static/img/detail_nivea_01.35d739f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/nivea-100-year-sweepstakes-microsite/detail_nivea_01.jpg
// module id = 268
// module chunks = 2